
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexYeY4OB0W74WNqzLI0qELNNOHYg1Bo7ccrZOf_vwrpP8Meta } from "/work/pages/faq/index.vue?macro=true";
import { default as indexJyBWVibnkMmfNnXvnOBONlyQLaBT_45S9yrnJz_45yEA0GoMeta } from "/work/pages/map/index.vue?macro=true";
import { default as _91id_93wnv1vLla8l610dANWOx_ontiJ9JjZBrtkL_IS_gcYBkMeta } from "/work/pages/quiz/[id].vue?macro=true";
import { default as mockswSP21AYjbaSfAbMR19BA7JIfbgZhZJ8ElVMRpyoi92EMeta } from "/work/pages/index/mocks.ts?macro=true";
import { default as indexIRx_45fg5PTsB8JqxI6Hlnco8s3ODV86_BYhvg6ZP8fXkMeta } from "/work/pages/news/index.vue?macro=true";
import { default as index2MGqvv_FIY6e3bWZzyBEl0PA3wqlBZt4iNvC8gjuQfQMeta } from "/work/pages/about/index.vue?macro=true";
import { default as requestC1spcrCtFPZbdK4N_JIy1YoH_45flYOI57x1nsIre4uvAMeta } from "/work/pages/b2b/request.vue?macro=true";
import { default as _91slug_93pF00kMdz3d0F9vsMSDsCWXFYB48j09uAtrzVVj67R54Meta } from "/work/pages/bank/[slug].vue?macro=true";
import { default as indexZU78s0IfVbHj1TszZn6l19qoOIx_eSD3_45YvrSjTkiSIMeta } from "/work/pages/banks/index.vue?macro=true";
import { default as indexhRsvCfai_qEmuivehaVZHFrCudukehV6ddX3_e1aIdAMeta } from "/work/pages/index/index.vue?macro=true";
import { default as indexHf0856Y3ib_45dXbw_45X5orZsNAd_45ew9k9QDYnrKopHYtsMeta } from "/work/pages/login/index.vue?macro=true";
import { default as _91slug_937pGHQ3jEetwO0WeLgTZzskp_498IYCiwwGAfjD_h5vIMeta } from "/work/pages/news/[slug].vue?macro=true";
import { default as indexx8iwUKDHuNiK2wZvUy5z7pIoOH9eN3VpovI7dsJrf7wMeta } from "/work/pages/panel/index.vue?macro=true";
import { default as index9efX_45dnRTwwUPsWa5M9ImjgO4WdGcgp81sl4Dl5bue4Meta } from "/work/pages/rates/index.vue?macro=true";
import { default as add9z9y_4rWyfse8ejYj_45gKa7ZV90qM48ZrOSTb_Elp6dMMeta } from "/work/pages/reviews/add.vue?macro=true";
import { default as _91slug_93nIWhv0FEBQyW9SAH2tSye2YCo4nE2QutQw_3jKBoEkIMeta } from "/work/pages/banks/[slug].vue?macro=true";
import { default as ratingyy4hb1Tw6RJtr_dT1xqTmwXk_PhPs42PV6P9NhJ7CicMeta } from "/work/pages/cards/rating.vue?macro=true";
import { default as indexN8pB1H6H0Acnj11pDZ6AbsYQVVHyfQVUUFXtVJ_4530YoMeta } from "/work/pages/events/index.vue?macro=true";
import { default as indexO2B_45EEAGFtddM9YbGfykJRm0SP9w2fVyDy0Q9QcenQkMeta } from "/work/pages/authors/index.vue?macro=true";
import { default as indexCtdMQQyliVLdSI4Sqag5ffvtkDXbfrLgN_MmIitTmaoMeta } from "/work/pages/compare/index.vue?macro=true";
import { default as _91slug_93bkkJCHPcbeRgbjqGiSV5XFcHGLJGOTse6reKPXjlBMYMeta } from "/work/pages/events/[slug].vue?macro=true";
import { default as indexy6CmD1dfCObZAaQZ4p3Btn9Vb8zjVfRJT_CAU2hJWXUMeta } from "/work/pages/partner/index.vue?macro=true";
import { default as _91id_93RfuvbWvWqbvcp_45ZQREDs12Ln3wDp5yfKlpxRq9i0p40Meta } from "/work/pages/b2b/leads/[id].vue?macro=true";
import { default as indexR5FzXZRpTMFH4MpcEeHMzCOoFZ7YFO__458T6Lo8btvCoMeta } from "/work/pages/contacts/index.vue?macro=true";
import { default as rating2kV2BoouFM8XWZajhGEpk_98g6ofM79q7yPz6_P47T0Meta } from "/work/pages/credits/rating.vue?macro=true";
import { default as indexSqWu03rR_453DpVZ3mByICBaJbQk_M3460tCf30LFLr6UMeta } from "/work/pages/glossary/index.vue?macro=true";
import { default as indexnCAJGPJa7SQ674hcDG8FBjnfbgVT89ginBJ_fT_263gMeta } from "/work/pages/register/index.vue?macro=true";
import { default as index7QHCT3aqUkjhW0TYUK57FymUWSRjN1BMRMqXlQhnRvkMeta } from "/work/pages/b2b/leads/index.vue?macro=true";
import { default as _91type_939v88Moj9PBWpfunKdUWI5gAKpMb5yooWPRKLDhQt96kMeta } from "/work/pages/deposits/[type].vue?macro=true";
import { default as rating_45Rs62PeipHL_45eOIU2Bs2_45GvOsD9oOOXgK2XngH51B4AMeta } from "/work/pages/deposits/rating.vue?macro=true";
import { default as indexegGtkBldWMjfkyjrpUMpOFuHkuYuwM3YAQwEje3aQE8Meta } from "/work/pages/marketing/index.vue?macro=true";
import { default as indexl1C193pReyCEp1mUh47y1gs_45j1Nhvu0NxuHswwv4ResMeta } from "/work/pages/vacancies/index.vue?macro=true";
import { default as indexSOHpHydYfNBL5Uv_45OvTrdFDdGTq7okVHjLpP0XP5BG4Meta } from "/work/pages/banks-info/index.vue?macro=true";
import { default as mortgagewDu8ZqhHIKkmmgFyocKmBlDwUWRjeoijNG9I_ppdvIMMeta } from "/work/pages/credits/mortgage.vue?macro=true";
import { default as indexsxj_FfIlHeV8fO9NlTdg_GEj8BDTSEP5XlbWILa1j_45oMeta } from "/work/pages/developers/index.vue?macro=true";
import { default as _91slug_93qH0GEB_PssUGB_45DfNCrNxo6kRXSavZ0StXOZZBb8AwQMeta } from "/work/pages/insurance/[slug].vue?macro=true";
import { default as indexupEiG8kFM6yAf45zcni9dPrkQ2FT4f3yXjgk7DZgCnQMeta } from "/work/pages/rates/nbkr/index.vue?macro=true";
import { default as indexD5PBpu4Mu85WKYDrcX8_kOugidilzqTf8iFCbMojY_AMeta } from "/work/pages/application/index.vue?macro=true";
import { default as _91_91_46_46_46slug_93_93B_wx_V6xS1QTF60yhJKZHKPv_x2xqa4LTIghNX1pKekMeta } from "/work/pages/cards/[[...slug]].vue?macro=true";
import { default as indexwTuEvfKu62SJH_45kdTetDgxJnBXjtRLw_E_45gRPPVb_TMMeta } from "/work/pages/cooperation/index.vue?macro=true";
import { default as _91type_93rm3_454mioMzwbiiXcRxf7LqDgO5E5DQf8UKXgliGJHm0Meta } from "/work/pages/insurances/[type].vue?macro=true";
import { default as indexp013y0AOwk_45VbKS5eTRECICZSitjdqRBsV1y7xDBipMMeta } from "/work/pages/clients-info/index.vue?macro=true";
import { default as selectionx8WIlekI_TGCGg_9rkbN1OKNznh7ZoTQpqVj6joE5p4Meta } from "/work/pages/deposits/selection.vue?macro=true";
import { default as createhnqIzIoURXaFiN3qtlKmllEnYOEGgZPClEHbQR6lCwYMeta } from "/work/pages/discussions/create.vue?macro=true";
import { default as _91slug_93rbHRZ8FaRpWUaus6LckYCX5qWbNOwKCApI52UlsyfksMeta } from "/work/pages/microcredit/[slug].vue?macro=true";
import { default as _91id_93gP_rtzEzvnqI0nXPk0FOhwwGMueGgqlgEUexxgV_KYwMeta } from "/work/pages/profile/leads/[id].vue?macro=true";
import { default as _91_91_46_46_46slug_93_93nEbmMJ7sAmqMer9_45yObFOvCSwWWqw1Wa7ipA4mctyPEMeta } from "/work/pages/credits/[[...slug]].vue?macro=true";
import { default as calculatorTxhSKwk3Z3JC1LRjSW_hR7wmnC_tGPwX6NApOz5gv3IMeta } from "/work/pages/deposits/calculator.vue?macro=true";
import { default as _91type_93Q_45jwaKvEceZ9fX4oZrUlvfR46_45IQ9IDrm9qOoaBKJVoMeta } from "/work/pages/microcredits/[type].vue?macro=true";
import { default as index23wCEW3fJvRNMj1sm8HlIQWrOVIPhiESg6S0VMJ32R4Meta } from "/work/pages/panel/profile/index.vue?macro=true";
import { default as indexaxawDDmT2M2yiWyaFRRcKe4SsjpROg2qHffrr_45WaEy4Meta } from "/work/pages/profile/leads/index.vue?macro=true";
import { default as indexADZNbUCnhWp5wGkeuCIDpK46FMXDFl5HhmwLN8XGJ70Meta } from "/work/pages/guarantee-fund/index.vue?macro=true";
import { default as indexqtHEOpmGNExrIIRAnEdKfO3eHSPVYlpTLMe8qU0ZUpoMeta } from "/work/pages/password/reset/index.vue?macro=true";
import { default as indexWD0p_456K2Cyq974u6Nl9G2bwqSDOlOcPQoOoO3Pwj6SYMeta } from "/work/pages/privacy-policy/index.vue?macro=true";
import { default as _91slug_93rH6qUWZVMsghpxYh2CJE_45ozTCHv1tRLdFlaHEVR8_NAMeta } from "/work/pages/money-transfer/[slug].vue?macro=true";
import { default as indexyUv17EhKxzWYk3jtznlqZ8YIv_452ORL0TmFe0ia_45jWkkMeta } from "/work/pages/panel/favorites/index.vue?macro=true";
import { default as _91currency_93xREiooZFmzRFDR7w1hlXBTa7iAGdn_452Q1Fq30VwNx34Meta } from "/work/pages/rates/nbkr/[currency].vue?macro=true";
import { default as indexmEe_rO79_45F23KoM11hSsCpp2dvVNZy9qOWa4_45h_45kO4AMeta } from "/work/pages/bank/[bank]/news/index.vue?macro=true";
import { default as index735kRbTmHlRwKIAX4n_gRA2ONkMLsmbwIftVegkOWI0Meta } from "/work/pages/banks/statistics/index.vue?macro=true";
import { default as online_45request7re7_EdOtnjfk4T_2YmsfK1nIbGA5wmgQ_45MiRcgrB18Meta } from "/work/pages/credits/online-request.vue?macro=true";
import { default as indexGXkNPHolRD8VgKNXpJCEaamrwWgVjA7FCcRf2riDYgYMeta } from "/work/pages/crypto-companies/index.vue?macro=true";
import { default as _91category_93uSVzsAkL7o1jGiNWZlq_45ryJbNQ_Fna4lpuCxK8YdA9UMeta } from "/work/pages/discussions/[category].vue?macro=true";
import { default as indexuNQY23_45Qx7AOjoF7iD4_oUJGWhMIvTQ9m_45eQk38_gO0Meta } from "/work/pages/exchange-offices/index.vue?macro=true";
import { default as _91type_93mEEU4Z8r731XX95801kGamV6nqvt8WoO7TD9KI9W_moMeta } from "/work/pages/money-transfers/[type].vue?macro=true";
import { default as _91token_932XWWZGeEBWGfcMFLZ44fF_FifX_3vhrg73oh5dgWghMMeta } from "/work/pages/password/reset/[token].vue?macro=true";
import { default as indexvjo_g3enbggJKRxqVT1iDp2_C2SENA1_45jg6BTxNsgLUMeta } from "/work/pages/rates/[currency]/index.vue?macro=true";
import { default as index77cDkEgTYK9APM0QHZ7KHndXytbAsg_QSUpFpHum91cMeta } from "/work/pages/register/success/index.vue?macro=true";
import { default as indexLTNl1Z1_45lbCRr_O5p81_qsWxWWCnPyhdzaT9P6A_I9wMeta } from "/work/pages/bank/[bank]/cards/index.vue?macro=true";
import { default as indexi5_Tf8cl64olQcxMUzbgOS2FXuJN_IcoGA821Nv63A4Meta } from "/work/pages/bank/[bank]/rates/index.vue?macro=true";
import { default as _91credit_93MXCJT4vlGtnRxFJh9TfK3W7MCNJkrso2z5y103RfF0EMeta } from "/work/pages/credits/detail/[credit].vue?macro=true";
import { default as _91slug_93pCTk_ZOWcAEKc8Q2h1QzCmsrY_45AVBxO2FVGdjPUP_moMeta } from "/work/pages/crypto-companies/[slug].vue?macro=true";
import { default as indexuu657V_45_0AyGij8bjhFhK7nKlw2GXcwExgJ1G0TV_6QMeta } from "/work/pages/panel/credit-lock/index.vue?macro=true";
import { default as _91card_935nr_453ScvzOLOrAvUJqZgakflryaTeHIXtrMk3KQI74EMeta } from "/work/pages/bank/[bank]/cards/[card].vue?macro=true";
import { default as indexWb7QTUQFT8qL3OTh3ZVBaAMFXSfWNANJtKlYuGhenGgMeta } from "/work/pages/panel/profile/edit/index.vue?macro=true";
import { default as indexPIi_45UhhMb8tcdHwQ_458dWbYptzhZsy8XPD40eqiJHabcMeta } from "/work/pages/under-construction/index.vue?macro=true";
import { default as indexiaH_45H3GB0SY3aAyl7_45m4PgSxRz767NQXzwDLRArKKQ0Meta } from "/work/pages/bank/[bank]/credits/index.vue?macro=true";
import { default as _91_46_46_46type_93m4w9B8Ds6SKZl3Bi1v_C4J4gnCXUB69Tnq5DPaSL97AMeta } from "/work/pages/bank/[bank]/map/[...type].vue?macro=true";
import { default as _91deposit_93_45ovnSSbeR_45HFtPKoyG3YarL5JGGXr6arkUkwIWdzSFMMeta } from "/work/pages/deposits/detail/[deposit].vue?macro=true";
import { default as index2rOPr_45j4WMlZ3kxYb_45ed9sbrodiUMHWQOqX7m_45q36jQMeta } from "/work/pages/bank/[bank]/deposits/index.vue?macro=true";
import { default as indexJlGS0UbW_45e5j5tfS_45a2hrA6xZCSBQUfTFobb9lCp3iQMeta } from "/work/pages/rates/[currency]/buy/index.vue?macro=true";
import { default as _91vacancy_93qYKEqq9kjvt13Voyt7oWEGugmiYiFnvQsUI_fg2fkKcMeta } from "/work/pages/vacancies/detail/[vacancy].vue?macro=true";
import { default as indexSa7Z290rmXaboirVm9XbfcoczasDOWlLXsY2S_uD9hEMeta } from "/work/pages/bank/[bank]/vacancies/index.vue?macro=true";
import { default as _91question_93KH1iSL6bJf4718OBdrmgDuRE7NzqkMC9coGrFSHCfNIMeta } from "/work/pages/discussions/view/[question].vue?macro=true";
import { default as indexJpmSPNgPEJ_450iOnHVnJea4GtVpfGy3r0B2cuXa3RzuEMeta } from "/work/pages/rates/[currency]/sell/index.vue?macro=true";
import { default as _91type_93O4Kvt1M7yANic19y9kWBWTSSOK4rhJe_45Zzemb1dQAakMeta } from "/work/pages/crypto-companies/type/[type].vue?macro=true";
import { default as _91value_93oKsPPlBii8eWpZ1Kq5FwjW_45mbjK27wKd4HowSmBP1x8Meta } from "/work/pages/rates/[currency]/buy/[value].vue?macro=true";
import { default as _91value_93wSoNbgsnr8lfqQ6Ew3oP8txuRcuNrW5H6DZ8LlTBZAcMeta } from "/work/pages/rates/[currency]/sell/[value].vue?macro=true";
import { default as indextnogeSAmALFhgTLWHyz1PizWrbsY9_wjcuXkBXXXfI8Meta } from "/work/pages/deposit-protection-agency/index.vue?macro=true";
import { default as _91hash_93_46client6kmdvy_zI_tQiVmmWFbzgQhpNT2zGatYWHecH8xd3BgMeta } from "/work/pages/email/verify/[id]/[hash].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/work/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexTNXURcdNDhwe2pbFbze8CuM1a42MCDZA_45xCxbKcs7AQMeta } from "/work/pages/bank/[bank]/money-transfers/index.vue?macro=true";
import { default as indexqhX5Y6gkk5fKaPc9un9QpowMs_45_dZMrfLk9Id3mB1bUMeta } from "/work/pages/microcredit/[microcredit]/news/index.vue?macro=true";
import { default as index73oLC897EpnSWtWcyjxK4eclUcNHs5JFCQjYkS5Z0TYMeta } from "/work/pages/microcredit/[microcredit]/rates/index.vue?macro=true";
import { default as indexcmNsDlBEETsPhBdF9gQsR4zjLeZ0WMQimlM5rSW3bCMMeta } from "/work/pages/microcredit/[microcredit]/credits/index.vue?macro=true";
import { default as _91_46_46_46type_93DkLqzW8rT5ppKaaJFqbWG0UgwIlDYzRyzn61Xejx9OAMeta } from "/work/pages/microcredit/[microcredit]/map/[...type].vue?macro=true";
import { default as indexJGkIW_45t3RmN_45q42K7ZKXDpT0z7ySAyQqstkKQU4H_45MQMeta } from "/work/pages/microcredit/[microcredit]/deposits/index.vue?macro=true";
import { default as indexf22fCSQvOj_45QvH7X72hiUjzZZLlM3NXuF2WmA_mMIdoMeta } from "/work/pages/microcredit/[microcredit]/vacancies/index.vue?macro=true";
export default [
  {
    name: "faq___ru",
    path: "/faq",
    component: () => import("/work/pages/faq/index.vue")
  },
  {
    name: "faq___ky",
    path: "/ky/faq",
    component: () => import("/work/pages/faq/index.vue")
  },
  {
    name: "map___ru",
    path: "/map",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "map___ky",
    path: "/ky/map",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "quiz-id___ru",
    path: "/quiz/:id()",
    component: () => import("/work/pages/quiz/[id].vue")
  },
  {
    name: "quiz-id___ky",
    path: "/ky/quiz/:id()",
    component: () => import("/work/pages/quiz/[id].vue")
  },
  {
    name: "index-mocks___ru",
    path: "//mocks",
    component: () => import("/work/pages/index/mocks.ts")
  },
  {
    name: "index-mocks___ky",
    path: "/ky//mocks",
    component: () => import("/work/pages/index/mocks.ts")
  },
  {
    name: "news___ru",
    path: "/news",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news___ky",
    path: "/ky/news",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "about___ru",
    path: "/about",
    component: () => import("/work/pages/about/index.vue")
  },
  {
    name: "about___ky",
    path: "/ky/about",
    component: () => import("/work/pages/about/index.vue")
  },
  {
    name: "b2b-request___ru",
    path: "/b2b/request",
    component: () => import("/work/pages/b2b/request.vue")
  },
  {
    name: "b2b-request___ky",
    path: "/ky/b2b/request",
    component: () => import("/work/pages/b2b/request.vue")
  },
  {
    name: "bank-slug___ru",
    path: "/bank/:slug()",
    component: () => import("/work/pages/bank/[slug].vue")
  },
  {
    name: "bank-slug___ky",
    path: "/ky/bank/:slug()",
    component: () => import("/work/pages/bank/[slug].vue")
  },
  {
    name: "banks___ru",
    path: "/banks",
    component: () => import("/work/pages/banks/index.vue")
  },
  {
    name: "banks___ky",
    path: "/ky/banks",
    component: () => import("/work/pages/banks/index.vue")
  },
  {
    name: "index___ru",
    path: "/",
    component: () => import("/work/pages/index/index.vue")
  },
  {
    name: "index___ky",
    path: "/ky",
    component: () => import("/work/pages/index/index.vue")
  },
  {
    name: "login___ru",
    path: "/login",
    component: () => import("/work/pages/login/index.vue")
  },
  {
    name: "login___ky",
    path: "/ky/login",
    component: () => import("/work/pages/login/index.vue")
  },
  {
    name: "news-slug___ru",
    path: "/news/:slug()",
    component: () => import("/work/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ky",
    path: "/ky/news/:slug()",
    component: () => import("/work/pages/news/[slug].vue")
  },
  {
    name: "panel___ru",
    path: "/panel",
    component: () => import("/work/pages/panel/index.vue")
  },
  {
    name: "panel___ky",
    path: "/ky/panel",
    component: () => import("/work/pages/panel/index.vue")
  },
  {
    name: "rates___ru",
    path: "/rates",
    component: () => import("/work/pages/rates/index.vue")
  },
  {
    name: "rates___ky",
    path: "/ky/rates",
    component: () => import("/work/pages/rates/index.vue")
  },
  {
    name: "reviews-add___ru",
    path: "/reviews/add",
    component: () => import("/work/pages/reviews/add.vue")
  },
  {
    name: "reviews-add___ky",
    path: "/ky/reviews/add",
    component: () => import("/work/pages/reviews/add.vue")
  },
  {
    name: "banks-slug___ru",
    path: "/banks/:slug()",
    component: () => import("/work/pages/banks/[slug].vue")
  },
  {
    name: "banks-slug___ky",
    path: "/ky/banks/:slug()",
    component: () => import("/work/pages/banks/[slug].vue")
  },
  {
    name: "cards-rating___ru",
    path: "/cards/rating",
    meta: ratingyy4hb1Tw6RJtr_dT1xqTmwXk_PhPs42PV6P9NhJ7CicMeta || {},
    component: () => import("/work/pages/cards/rating.vue")
  },
  {
    name: "cards-rating___ky",
    path: "/ky/cards/rating",
    meta: ratingyy4hb1Tw6RJtr_dT1xqTmwXk_PhPs42PV6P9NhJ7CicMeta || {},
    component: () => import("/work/pages/cards/rating.vue")
  },
  {
    name: "events___ru",
    path: "/events",
    component: () => import("/work/pages/events/index.vue")
  },
  {
    name: "events___ky",
    path: "/ky/events",
    component: () => import("/work/pages/events/index.vue")
  },
  {
    name: "authors___ru",
    path: "/authors",
    component: () => import("/work/pages/authors/index.vue")
  },
  {
    name: "authors___ky",
    path: "/ky/authors",
    component: () => import("/work/pages/authors/index.vue")
  },
  {
    name: "compare___ru",
    path: "/compare",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "compare___ky",
    path: "/ky/compare",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "events-slug___ru",
    path: "/events/:slug()",
    component: () => import("/work/pages/events/[slug].vue")
  },
  {
    name: "events-slug___ky",
    path: "/ky/events/:slug()",
    component: () => import("/work/pages/events/[slug].vue")
  },
  {
    name: "partner___ru",
    path: "/partner",
    component: () => import("/work/pages/partner/index.vue")
  },
  {
    name: "partner___ky",
    path: "/ky/partner",
    component: () => import("/work/pages/partner/index.vue")
  },
  {
    name: "b2b-leads-id___ru",
    path: "/b2b/leads/:id()",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/b2b/leads/[id].vue")
  },
  {
    name: "b2b-leads-id___ky",
    path: "/ky/b2b/leads/:id()",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/b2b/leads/[id].vue")
  },
  {
    name: "contacts___ru",
    path: "/contacts",
    component: () => import("/work/pages/contacts/index.vue")
  },
  {
    name: "contacts___ky",
    path: "/ky/contacts",
    component: () => import("/work/pages/contacts/index.vue")
  },
  {
    name: "credits-rating___ru",
    path: "/credits/rating",
    meta: rating2kV2BoouFM8XWZajhGEpk_98g6ofM79q7yPz6_P47T0Meta || {},
    component: () => import("/work/pages/credits/rating.vue")
  },
  {
    name: "credits-rating___ky",
    path: "/ky/credits/rating",
    meta: rating2kV2BoouFM8XWZajhGEpk_98g6ofM79q7yPz6_P47T0Meta || {},
    component: () => import("/work/pages/credits/rating.vue")
  },
  {
    name: "glossary___ru",
    path: "/glossary",
    component: () => import("/work/pages/glossary/index.vue")
  },
  {
    name: "glossary___ky",
    path: "/ky/glossary",
    component: () => import("/work/pages/glossary/index.vue")
  },
  {
    name: "register___ru",
    path: "/register",
    component: () => import("/work/pages/register/index.vue")
  },
  {
    name: "register___ky",
    path: "/ky/register",
    component: () => import("/work/pages/register/index.vue")
  },
  {
    name: "b2b-leads___ru",
    path: "/b2b/leads",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/b2b/leads/index.vue")
  },
  {
    name: "b2b-leads___ky",
    path: "/ky/b2b/leads",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/b2b/leads/index.vue")
  },
  {
    name: "deposits-type___ru",
    path: "/deposits",
    meta: _91type_939v88Moj9PBWpfunKdUWI5gAKpMb5yooWPRKLDhQt96kMeta || {},
    alias: ["/deposits/:type(.*)*"],
    component: () => import("/work/pages/deposits/[type].vue")
  },
  {
    name: "deposits-type___ky",
    path: "/ky/deposits",
    meta: _91type_939v88Moj9PBWpfunKdUWI5gAKpMb5yooWPRKLDhQt96kMeta || {},
    alias: ["/ky/deposits/:type(.*)*"],
    component: () => import("/work/pages/deposits/[type].vue")
  },
  {
    name: "deposits-rating___ru",
    path: "/deposits/rating",
    meta: rating_45Rs62PeipHL_45eOIU2Bs2_45GvOsD9oOOXgK2XngH51B4AMeta || {},
    component: () => import("/work/pages/deposits/rating.vue")
  },
  {
    name: "deposits-rating___ky",
    path: "/ky/deposits/rating",
    meta: rating_45Rs62PeipHL_45eOIU2Bs2_45GvOsD9oOOXgK2XngH51B4AMeta || {},
    component: () => import("/work/pages/deposits/rating.vue")
  },
  {
    name: "marketing___ru",
    path: "/marketing",
    component: () => import("/work/pages/marketing/index.vue")
  },
  {
    name: "marketing___ky",
    path: "/ky/marketing",
    component: () => import("/work/pages/marketing/index.vue")
  },
  {
    name: "vacancies___ru",
    path: "/vacancies",
    component: () => import("/work/pages/vacancies/index.vue")
  },
  {
    name: "vacancies___ky",
    path: "/ky/vacancies",
    component: () => import("/work/pages/vacancies/index.vue")
  },
  {
    name: "banks-info___ru",
    path: "/banks-info",
    component: () => import("/work/pages/banks-info/index.vue")
  },
  {
    name: "banks-info___ky",
    path: "/ky/banks-info",
    component: () => import("/work/pages/banks-info/index.vue")
  },
  {
    name: "credits-mortgage___ru",
    path: "/credits/mortgage",
    component: () => import("/work/pages/credits/mortgage.vue")
  },
  {
    name: "credits-mortgage___ky",
    path: "/ky/credits/mortgage",
    component: () => import("/work/pages/credits/mortgage.vue")
  },
  {
    name: "developers___ru",
    path: "/developers",
    component: () => import("/work/pages/developers/index.vue")
  },
  {
    name: "developers___ky",
    path: "/ky/developers",
    component: () => import("/work/pages/developers/index.vue")
  },
  {
    name: "insurance-slug___ru",
    path: "/insurance/:slug()",
    component: () => import("/work/pages/insurance/[slug].vue")
  },
  {
    name: "insurance-slug___ky",
    path: "/ky/insurance/:slug()",
    component: () => import("/work/pages/insurance/[slug].vue")
  },
  {
    name: "rates-nbkr___ru",
    path: "/rates/nbkr",
    component: () => import("/work/pages/rates/nbkr/index.vue")
  },
  {
    name: "rates-nbkr___ky",
    path: "/ky/rates/nbkr",
    component: () => import("/work/pages/rates/nbkr/index.vue")
  },
  {
    name: "application___ru",
    path: "/application",
    component: () => import("/work/pages/application/index.vue")
  },
  {
    name: "application___ky",
    path: "/ky/application",
    component: () => import("/work/pages/application/index.vue")
  },
  {
    name: "cards-slug]___ru",
    path: "/cards",
    meta: _91_91_46_46_46slug_93_93B_wx_V6xS1QTF60yhJKZHKPv_x2xqa4LTIghNX1pKekMeta || {},
    alias: ["/cards/:type(.*)*","/cards/system/:system(.*)*"],
    component: () => import("/work/pages/cards/[[...slug]].vue")
  },
  {
    name: "cards-slug]___ky",
    path: "/ky/cards",
    meta: _91_91_46_46_46slug_93_93B_wx_V6xS1QTF60yhJKZHKPv_x2xqa4LTIghNX1pKekMeta || {},
    alias: ["/ky/cards/:type(.*)*","/ky/cards/system/:system(.*)*"],
    component: () => import("/work/pages/cards/[[...slug]].vue")
  },
  {
    name: "cooperation___ru",
    path: "/cooperation",
    component: () => import("/work/pages/cooperation/index.vue")
  },
  {
    name: "cooperation___ky",
    path: "/ky/cooperation",
    component: () => import("/work/pages/cooperation/index.vue")
  },
  {
    name: "insurances-type___ru",
    path: "/insurances",
    meta: _91type_93rm3_454mioMzwbiiXcRxf7LqDgO5E5DQf8UKXgliGJHm0Meta || {},
    alias: ["/insurances/:type(.*)*"],
    component: () => import("/work/pages/insurances/[type].vue")
  },
  {
    name: "insurances-type___ky",
    path: "/ky/insurances",
    meta: _91type_93rm3_454mioMzwbiiXcRxf7LqDgO5E5DQf8UKXgliGJHm0Meta || {},
    alias: ["/ky/insurances/:type(.*)*"],
    component: () => import("/work/pages/insurances/[type].vue")
  },
  {
    name: "clients-info___ru",
    path: "/clients-info",
    component: () => import("/work/pages/clients-info/index.vue")
  },
  {
    name: "clients-info___ky",
    path: "/ky/clients-info",
    component: () => import("/work/pages/clients-info/index.vue")
  },
  {
    name: "deposits-selection___ru",
    path: "/deposits/selection",
    component: () => import("/work/pages/deposits/selection.vue")
  },
  {
    name: "deposits-selection___ky",
    path: "/ky/deposits/selection",
    component: () => import("/work/pages/deposits/selection.vue")
  },
  {
    name: "discussions-create___ru",
    path: "/discussions/create",
    component: () => import("/work/pages/discussions/create.vue")
  },
  {
    name: "discussions-create___ky",
    path: "/ky/discussions/create",
    component: () => import("/work/pages/discussions/create.vue")
  },
  {
    name: "microcredit-slug___ru",
    path: "/microcredit/:slug()",
    component: () => import("/work/pages/microcredit/[slug].vue")
  },
  {
    name: "microcredit-slug___ky",
    path: "/ky/microcredit/:slug()",
    component: () => import("/work/pages/microcredit/[slug].vue")
  },
  {
    name: "profile-leads-id___ru",
    path: "/profile/leads/:id()",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/profile/leads/[id].vue")
  },
  {
    name: "profile-leads-id___ky",
    path: "/ky/profile/leads/:id()",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/profile/leads/[id].vue")
  },
  {
    name: "credits-slug]___ru",
    path: "/credits",
    meta: _91_91_46_46_46slug_93_93nEbmMJ7sAmqMer9_45yObFOvCSwWWqw1Wa7ipA4mctyPEMeta || {},
    alias: ["/credits/purpose/:purpose(.*)*","/credits/:type(.*)*"],
    component: () => import("/work/pages/credits/[[...slug]].vue")
  },
  {
    name: "credits-slug]___ky",
    path: "/ky/credits",
    meta: _91_91_46_46_46slug_93_93nEbmMJ7sAmqMer9_45yObFOvCSwWWqw1Wa7ipA4mctyPEMeta || {},
    alias: ["/ky/credits/purpose/:purpose(.*)*","/ky/credits/:type(.*)*"],
    component: () => import("/work/pages/credits/[[...slug]].vue")
  },
  {
    name: "deposits-calculator___ru",
    path: "/deposits/calculator",
    component: () => import("/work/pages/deposits/calculator.vue")
  },
  {
    name: "deposits-calculator___ky",
    path: "/ky/deposits/calculator",
    component: () => import("/work/pages/deposits/calculator.vue")
  },
  {
    name: "microcredits-type___ru",
    path: "/microcredit",
    meta: _91type_93Q_45jwaKvEceZ9fX4oZrUlvfR46_45IQ9IDrm9qOoaBKJVoMeta || {},
    alias: ["/microcredits/:type(.*)*"],
    component: () => import("/work/pages/microcredits/[type].vue")
  },
  {
    name: "microcredits-type___ky",
    path: "/ky/microcredit",
    meta: _91type_93Q_45jwaKvEceZ9fX4oZrUlvfR46_45IQ9IDrm9qOoaBKJVoMeta || {},
    alias: ["/ky/microcredits/:type(.*)*"],
    component: () => import("/work/pages/microcredits/[type].vue")
  },
  {
    name: "panel-profile___ru",
    path: "/panel/profile",
    component: () => import("/work/pages/panel/profile/index.vue")
  },
  {
    name: "panel-profile___ky",
    path: "/ky/panel/profile",
    component: () => import("/work/pages/panel/profile/index.vue")
  },
  {
    name: "profile-leads___ru",
    path: "/profile/leads",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/profile/leads/index.vue")
  },
  {
    name: "profile-leads___ky",
    path: "/ky/profile/leads",
    meta: {"robots":"noindex"},
    component: () => import("/work/pages/profile/leads/index.vue")
  },
  {
    name: "guarantee-fund___ru",
    path: "/guarantee-fund",
    component: () => import("/work/pages/guarantee-fund/index.vue")
  },
  {
    name: "guarantee-fund___ky",
    path: "/ky/guarantee-fund",
    component: () => import("/work/pages/guarantee-fund/index.vue")
  },
  {
    name: "password-reset___ru",
    path: "/password/reset",
    component: () => import("/work/pages/password/reset/index.vue")
  },
  {
    name: "password-reset___ky",
    path: "/ky/password/reset",
    component: () => import("/work/pages/password/reset/index.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/privacy-policy",
    component: () => import("/work/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___ky",
    path: "/ky/privacy-policy",
    component: () => import("/work/pages/privacy-policy/index.vue")
  },
  {
    name: "money-transfer-slug___ru",
    path: "/money-transfer/:slug()",
    component: () => import("/work/pages/money-transfer/[slug].vue")
  },
  {
    name: "money-transfer-slug___ky",
    path: "/ky/money-transfer/:slug()",
    component: () => import("/work/pages/money-transfer/[slug].vue")
  },
  {
    name: "panel-favorites___ru",
    path: "/panel/favorites",
    component: () => import("/work/pages/panel/favorites/index.vue")
  },
  {
    name: "panel-favorites___ky",
    path: "/ky/panel/favorites",
    component: () => import("/work/pages/panel/favorites/index.vue")
  },
  {
    name: "rates-nbkr-currency___ru",
    path: "/rates/nbkr/:currency()",
    component: () => import("/work/pages/rates/nbkr/[currency].vue")
  },
  {
    name: "rates-nbkr-currency___ky",
    path: "/ky/rates/nbkr/:currency()",
    component: () => import("/work/pages/rates/nbkr/[currency].vue")
  },
  {
    name: "bank-bank-news___ru",
    path: "/bank/:bank()/news",
    component: () => import("/work/pages/bank/[bank]/news/index.vue")
  },
  {
    name: "bank-bank-news___ky",
    path: "/ky/bank/:bank()/news",
    component: () => import("/work/pages/bank/[bank]/news/index.vue")
  },
  {
    name: "banks-statistics___ru",
    path: "/banks/statistics",
    component: () => import("/work/pages/banks/statistics/index.vue")
  },
  {
    name: "banks-statistics___ky",
    path: "/ky/banks/statistics",
    component: () => import("/work/pages/banks/statistics/index.vue")
  },
  {
    name: "credits-online-request___ru",
    path: "/credits/online-request",
    component: () => import("/work/pages/credits/online-request.vue")
  },
  {
    name: "credits-online-request___ky",
    path: "/ky/credits/online-request",
    component: () => import("/work/pages/credits/online-request.vue")
  },
  {
    name: "crypto-companies___ru",
    path: "/crypto-companies",
    component: () => import("/work/pages/crypto-companies/index.vue")
  },
  {
    name: "crypto-companies___ky",
    path: "/ky/crypto-companies",
    component: () => import("/work/pages/crypto-companies/index.vue")
  },
  {
    name: "discussions-category___ru",
    path: "/discussions",
    meta: _91category_93uSVzsAkL7o1jGiNWZlq_45ryJbNQ_Fna4lpuCxK8YdA9UMeta || {},
    alias: ["/discussions/:category(.*)*"],
    component: () => import("/work/pages/discussions/[category].vue")
  },
  {
    name: "discussions-category___ky",
    path: "/ky/discussions",
    meta: _91category_93uSVzsAkL7o1jGiNWZlq_45ryJbNQ_Fna4lpuCxK8YdA9UMeta || {},
    alias: ["/ky/discussions/:category(.*)*"],
    component: () => import("/work/pages/discussions/[category].vue")
  },
  {
    name: "exchange-offices___ru",
    path: "/exchange-offices",
    component: () => import("/work/pages/exchange-offices/index.vue")
  },
  {
    name: "exchange-offices___ky",
    path: "/ky/exchange-offices",
    component: () => import("/work/pages/exchange-offices/index.vue")
  },
  {
    name: "money-transfers-type___ru",
    path: "/money-transfers",
    meta: _91type_93mEEU4Z8r731XX95801kGamV6nqvt8WoO7TD9KI9W_moMeta || {},
    alias: ["/money-transfers/:type(.*)*"],
    component: () => import("/work/pages/money-transfers/[type].vue")
  },
  {
    name: "money-transfers-type___ky",
    path: "/ky/money-transfers",
    meta: _91type_93mEEU4Z8r731XX95801kGamV6nqvt8WoO7TD9KI9W_moMeta || {},
    alias: ["/ky/money-transfers/:type(.*)*"],
    component: () => import("/work/pages/money-transfers/[type].vue")
  },
  {
    name: "password-reset-token___ru",
    path: "/password/reset/:token()",
    component: () => import("/work/pages/password/reset/[token].vue")
  },
  {
    name: "password-reset-token___ky",
    path: "/ky/password/reset/:token()",
    component: () => import("/work/pages/password/reset/[token].vue")
  },
  {
    name: "rates-currency___ru",
    path: "/rates/:currency()",
    component: () => import("/work/pages/rates/[currency]/index.vue")
  },
  {
    name: "rates-currency___ky",
    path: "/ky/rates/:currency()",
    component: () => import("/work/pages/rates/[currency]/index.vue")
  },
  {
    name: "register-success___ru",
    path: "/register/success",
    component: () => import("/work/pages/register/success/index.vue")
  },
  {
    name: "register-success___ky",
    path: "/ky/register/success",
    component: () => import("/work/pages/register/success/index.vue")
  },
  {
    name: "bank-bank-cards___ru",
    path: "/bank/:bank()/cards",
    component: () => import("/work/pages/bank/[bank]/cards/index.vue")
  },
  {
    name: "bank-bank-cards___ky",
    path: "/ky/bank/:bank()/cards",
    component: () => import("/work/pages/bank/[bank]/cards/index.vue")
  },
  {
    name: "bank-bank-rates___ru",
    path: "/bank/:bank()/rates",
    component: () => import("/work/pages/bank/[bank]/rates/index.vue")
  },
  {
    name: "bank-bank-rates___ky",
    path: "/ky/bank/:bank()/rates",
    component: () => import("/work/pages/bank/[bank]/rates/index.vue")
  },
  {
    name: "credits-detail-credit___ru",
    path: "/credits/detail/:credit()",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "credits-detail-credit___ky",
    path: "/ky/credits/detail/:credit()",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "crypto-companies-slug___ru",
    path: "/crypto-companies/:slug()",
    component: () => import("/work/pages/crypto-companies/[slug].vue")
  },
  {
    name: "crypto-companies-slug___ky",
    path: "/ky/crypto-companies/:slug()",
    component: () => import("/work/pages/crypto-companies/[slug].vue")
  },
  {
    name: "panel-credit-lock___ru",
    path: "/panel/credit-lock",
    component: () => import("/work/pages/panel/credit-lock/index.vue")
  },
  {
    name: "panel-credit-lock___ky",
    path: "/ky/panel/credit-lock",
    component: () => import("/work/pages/panel/credit-lock/index.vue")
  },
  {
    name: "bank-bank-cards-card___ru",
    path: "/bank/:bank()/cards/:card()",
    component: () => import("/work/pages/bank/[bank]/cards/[card].vue")
  },
  {
    name: "bank-bank-cards-card___ky",
    path: "/ky/bank/:bank()/cards/:card()",
    component: () => import("/work/pages/bank/[bank]/cards/[card].vue")
  },
  {
    name: "panel-profile-edit___ru",
    path: "/panel/profile/edit",
    component: () => import("/work/pages/panel/profile/edit/index.vue")
  },
  {
    name: "panel-profile-edit___ky",
    path: "/ky/panel/profile/edit",
    component: () => import("/work/pages/panel/profile/edit/index.vue")
  },
  {
    name: "under-construction___ru",
    path: "/under-construction",
    component: () => import("/work/pages/under-construction/index.vue")
  },
  {
    name: "under-construction___ky",
    path: "/ky/under-construction",
    component: () => import("/work/pages/under-construction/index.vue")
  },
  {
    name: "bank-bank-credits___ru",
    path: "/bank/:bank()/credits",
    component: () => import("/work/pages/bank/[bank]/credits/index.vue")
  },
  {
    name: "bank-bank-credits___ky",
    path: "/ky/bank/:bank()/credits",
    component: () => import("/work/pages/bank/[bank]/credits/index.vue")
  },
  {
    name: "bank-bank-map-type___ru",
    path: "/bank/:bank()/map/:type(.*)*",
    component: () => import("/work/pages/bank/[bank]/map/[...type].vue")
  },
  {
    name: "bank-bank-map-type___ky",
    path: "/ky/bank/:bank()/map/:type(.*)*",
    component: () => import("/work/pages/bank/[bank]/map/[...type].vue")
  },
  {
    name: "deposits-detail-deposit___ru",
    path: "/deposits/detail/:deposit()",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "deposits-detail-deposit___ky",
    path: "/ky/deposits/detail/:deposit()",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "bank-bank-deposits___ru",
    path: "/bank/:bank()/deposits",
    component: () => import("/work/pages/bank/[bank]/deposits/index.vue")
  },
  {
    name: "bank-bank-deposits___ky",
    path: "/ky/bank/:bank()/deposits",
    component: () => import("/work/pages/bank/[bank]/deposits/index.vue")
  },
  {
    name: "rates-currency-buy___ru",
    path: "/rates/:currency()/buy",
    component: () => import("/work/pages/rates/[currency]/buy/index.vue")
  },
  {
    name: "rates-currency-buy___ky",
    path: "/ky/rates/:currency()/buy",
    component: () => import("/work/pages/rates/[currency]/buy/index.vue")
  },
  {
    name: "vacancies-detail-vacancy___ru",
    path: "/vacancies/detail/:vacancy()",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "vacancies-detail-vacancy___ky",
    path: "/ky/vacancies/detail/:vacancy()",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "bank-bank-vacancies___ru",
    path: "/bank/:bank()/vacancies",
    component: () => import("/work/pages/bank/[bank]/vacancies/index.vue")
  },
  {
    name: "bank-bank-vacancies___ky",
    path: "/ky/bank/:bank()/vacancies",
    component: () => import("/work/pages/bank/[bank]/vacancies/index.vue")
  },
  {
    name: "discussions-view-question___ru",
    path: "/discussions/view/:question()",
    component: () => import("/work/pages/discussions/view/[question].vue")
  },
  {
    name: "discussions-view-question___ky",
    path: "/ky/discussions/view/:question()",
    component: () => import("/work/pages/discussions/view/[question].vue")
  },
  {
    name: "rates-currency-sell___ru",
    path: "/rates/:currency()/sell",
    component: () => import("/work/pages/rates/[currency]/sell/index.vue")
  },
  {
    name: "rates-currency-sell___ky",
    path: "/ky/rates/:currency()/sell",
    component: () => import("/work/pages/rates/[currency]/sell/index.vue")
  },
  {
    name: "crypto-companies-type-type___ru",
    path: "/crypto-companies/type/:type()",
    component: () => import("/work/pages/crypto-companies/type/[type].vue")
  },
  {
    name: "crypto-companies-type-type___ky",
    path: "/ky/crypto-companies/type/:type()",
    component: () => import("/work/pages/crypto-companies/type/[type].vue")
  },
  {
    name: "rates-currency-buy-value___ru",
    path: "/rates/:currency()/buy/:value()",
    component: () => import("/work/pages/rates/[currency]/buy/[value].vue")
  },
  {
    name: "rates-currency-buy-value___ky",
    path: "/ky/rates/:currency()/buy/:value()",
    component: () => import("/work/pages/rates/[currency]/buy/[value].vue")
  },
  {
    name: "rates-currency-sell-value___ru",
    path: "/rates/:currency()/sell/:value()",
    component: () => import("/work/pages/rates/[currency]/sell/[value].vue")
  },
  {
    name: "rates-currency-sell-value___ky",
    path: "/ky/rates/:currency()/sell/:value()",
    component: () => import("/work/pages/rates/[currency]/sell/[value].vue")
  },
  {
    name: "deposit-protection-agency___ru",
    path: "/deposit-protection-agency",
    component: () => import("/work/pages/deposit-protection-agency/index.vue")
  },
  {
    name: "deposit-protection-agency___ky",
    path: "/ky/deposit-protection-agency",
    component: () => import("/work/pages/deposit-protection-agency/index.vue")
  },
  {
    name: "email-verify-id-hash___ru",
    path: "/email/verify/:id()/:hash()",
    component: () => createClientPage(() => import("/work/pages/email/verify/[id]/[hash].client.vue"))
  },
  {
    name: "email-verify-id-hash___ky",
    path: "/ky/email/verify/:id()/:hash()",
    component: () => createClientPage(() => import("/work/pages/email/verify/[id]/[hash].client.vue"))
  },
  {
    name: "bank-bank-money-transfers___ru",
    path: "/bank/:bank()/money-transfers",
    component: () => import("/work/pages/bank/[bank]/money-transfers/index.vue")
  },
  {
    name: "bank-bank-money-transfers___ky",
    path: "/ky/bank/:bank()/money-transfers",
    component: () => import("/work/pages/bank/[bank]/money-transfers/index.vue")
  },
  {
    name: "microcredit-microcredit-news___ru",
    path: "/microcredit/:microcredit()/news",
    component: () => import("/work/pages/microcredit/[microcredit]/news/index.vue")
  },
  {
    name: "microcredit-microcredit-news___ky",
    path: "/ky/microcredit/:microcredit()/news",
    component: () => import("/work/pages/microcredit/[microcredit]/news/index.vue")
  },
  {
    name: "microcredit-microcredit-rates___ru",
    path: "/microcredit/:microcredit()/rates",
    component: () => import("/work/pages/microcredit/[microcredit]/rates/index.vue")
  },
  {
    name: "microcredit-microcredit-rates___ky",
    path: "/ky/microcredit/:microcredit()/rates",
    component: () => import("/work/pages/microcredit/[microcredit]/rates/index.vue")
  },
  {
    name: "microcredit-microcredit-credits___ru",
    path: "/microcredit/:microcredit()/credits",
    component: () => import("/work/pages/microcredit/[microcredit]/credits/index.vue")
  },
  {
    name: "microcredit-microcredit-credits___ky",
    path: "/ky/microcredit/:microcredit()/credits",
    component: () => import("/work/pages/microcredit/[microcredit]/credits/index.vue")
  },
  {
    name: "microcredit-microcredit-map-type___ru",
    path: "/microcredit/:microcredit()/map/:type(.*)*",
    component: () => import("/work/pages/microcredit/[microcredit]/map/[...type].vue")
  },
  {
    name: "microcredit-microcredit-map-type___ky",
    path: "/ky/microcredit/:microcredit()/map/:type(.*)*",
    component: () => import("/work/pages/microcredit/[microcredit]/map/[...type].vue")
  },
  {
    name: "microcredit-microcredit-deposits___ru",
    path: "/microcredit/:microcredit()/deposits",
    component: () => import("/work/pages/microcredit/[microcredit]/deposits/index.vue")
  },
  {
    name: "microcredit-microcredit-deposits___ky",
    path: "/ky/microcredit/:microcredit()/deposits",
    component: () => import("/work/pages/microcredit/[microcredit]/deposits/index.vue")
  },
  {
    name: "microcredit-microcredit-vacancies___ru",
    path: "/microcredit/:microcredit()/vacancies",
    component: () => import("/work/pages/microcredit/[microcredit]/vacancies/index.vue")
  },
  {
    name: "microcredit-microcredit-vacancies___ky",
    path: "/ky/microcredit/:microcredit()/vacancies",
    component: () => import("/work/pages/microcredit/[microcredit]/vacancies/index.vue")
  },
  {
    name: "useful-articles___ru",
    path: "/useful-articles",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "useful-articles___ky",
    path: "/ky/useful-articles",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "useful-articles-detail___ru",
    path: "/useful-articles/:slug",
    component: () => import("/work/pages/news/[slug].vue")
  },
  {
    name: "useful-articles-detail___ky",
    path: "/ky/useful-articles/:slug",
    component: () => import("/work/pages/news/[slug].vue")
  },
  {
    name: "news-date___ru",
    path: "/news/:year(\\d{4})/:month(\\d{2})/:day(\\d{2})",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-date___ky",
    path: "/ky/news/:year(\\d{4})/:month(\\d{2})/:day(\\d{2})",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-category___ru",
    path: "/news/category/:category(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-category___ky",
    path: "/ky/news/category/:category(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-author___ru",
    path: "/news/author/:author(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-author___ky",
    path: "/ky/news/author/:author(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-tag___ru",
    path: "/tag/:tag(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "news-tag___ky",
    path: "/ky/tag/:tag(.*)*",
    component: () => import("/work/pages/news/index.vue")
  },
  {
    name: "bank-deposit___ru",
    path: "/bank/:bank/deposits/:deposit",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "bank-deposit___ky",
    path: "/ky/bank/:bank/deposits/:deposit",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "microcredit-deposit___ru",
    path: "/microcredit/:microcredit/deposits/:deposit",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "microcredit-deposit___ky",
    path: "/ky/microcredit/:microcredit/deposits/:deposit",
    component: () => import("/work/pages/deposits/detail/[deposit].vue")
  },
  {
    name: "bank-credit___ru",
    path: "/bank/:bank/credits/:credit",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "bank-credit___ky",
    path: "/ky/bank/:bank/credits/:credit",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "microcredit-credit___ru",
    path: "/microcredit/:microcredit/credits/:credit",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "microcredit-credit___ky",
    path: "/ky/microcredit/:microcredit/credits/:credit",
    component: () => import("/work/pages/credits/detail/[credit].vue")
  },
  {
    name: "bank-vacancy___ru",
    path: "/bank/:bank/vacancies/:vacancy",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "bank-vacancy___ky",
    path: "/ky/bank/:bank/vacancies/:vacancy",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "microcredit-vacancy___ru",
    path: "/microcredit/:microcredit/vacancies/:vacancy",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "microcredit-vacancy___ky",
    path: "/ky/microcredit/:microcredit/vacancies/:vacancy",
    component: () => import("/work/pages/vacancies/detail/[vacancy].vue")
  },
  {
    name: "bank-branches___ru",
    path: "/bank/:bank/branches",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "bank-branches___ky",
    path: "/ky/bank/:bank/branches",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "microcredit-branches___ru",
    path: "/microcredit/:microcredit/branches",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "microcredit-branches___ky",
    path: "/ky/microcredit/:microcredit/branches",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "bank-atms___ru",
    path: "/bank/:bank/atms",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "bank-atms___ky",
    path: "/ky/bank/:bank/atms",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "bank-terminals___ru",
    path: "/bank/:bank/terminals",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "bank-terminals___ky",
    path: "/ky/bank/:bank/terminals",
    component: () => import("/work/pages/map/index.vue")
  },
  {
    name: "credits-compare___ru",
    path: "/compare/credits",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "credits-compare___ky",
    path: "/ky/compare/credits",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "deposits-compare___ru",
    path: "/compare/deposits",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "deposits-compare___ky",
    path: "/ky/compare/deposits",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "cards-compare___ru",
    path: "/compare/cards",
    component: () => import("/work/pages/compare/index.vue")
  },
  {
    name: "cards-compare___ky",
    path: "/ky/compare/cards",
    component: () => import("/work/pages/compare/index.vue")
  }
]